import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

// eslint-disable-next-line replo/no-zustand-create-or-usestore -- needs create()() for persist middleware
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ViewportStore {
  currentViewport: EditorCanvas;
  setCurrentViewport: (viewport: EditorCanvas) => void;
}

export const useViewportStore = create<ViewportStore>()(
  persist(
    (set) => ({
      currentViewport: "mobile",
      setCurrentViewport: (viewport) => set({ currentViewport: viewport }),
    }),
    {
      name: "replo-editor-viewport",
    },
  ),
);
